<template>
  <div class="w-full">
    <div class="py-10 w-full px-6">
      <div
        class="w-full flex flex-col lg:flex-row lg:items-center lg:justify-between mb-10"
      >
        <h1 class="font-bold text-gray-900 text-3xl">
          Seminare und Workshops
        </h1>
        <!-- <div class="flex items-center md:mb-0 mt-4">
          <div
            class="flex items-stretch border rounded border-gray-300 cursor-pointer"
          >
            <a class="px-4 py-2 text-gray-600 text-xs border-r border-gray-300"
              >Categorial</a
            >
            <a class="px-4 py-2 text-gray-600 text-xs border-r border-gray-300"
              >Alphabetical</a
            >
          </div>
          <div class="ml-5 text-gray-600 cursor-pointer">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="icon icon-tabler icon-tabler-search"
              width="28"
              height="28"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" />
              <circle cx="10" cy="10" r="7" />
              <line x1="21" y1="21" x2="15" y2="15" />
            </svg>
          </div>
        </div> -->
      </div>
      <h5 class="mb-6 text-gray-900 font-medium">Kommende Veranstaltungen</h5>

      <div
        class="flex flex-col-reverse lg:flex-row w-full bg-white shadow rounded"
      >
        <div class="w-full lg:w-1/2">
          <div class="pt-4 lg:pt-6 pb-4 lg:pb-6 pl-4 lg:pl-6 pr-4 lg:pr-6">
            <div
              class="flex justify-between items-center lg:items-start flex-row-reverse lg:flex-col"
            >
              <h4 class="text-base text-blue-700 tracking-normal leading-4">
                Wird definiert
              </h4>
              <h4
                class="lg:mt-3 lg:text-gray-600 text-blue-700 text-base font-normal"
              >
              Wird definiert
              </h4>
            </div>
            <h2
              class="text-gray-800 mt-4 mb-2 tracking-normal text-xl lg:text-2xl font-bold"
            >
              AI4Teachers - Künstliche Intelligenz in der Schule
            </h2>
            <h3
              class="text-gray-600 mt-4 mb-2 tracking-normal text-xl lg:text-2xl font-bold"
            >
              Modul 1 - Grundlagen KI
            </h3>
            <p
              class="mb-6 font-normal text-gray-600 text-sm tracking-normal w-11/12 lg:w-9/12"
            >
            Am Ende dieser Workshopreihe, werden die Teilnehmer die Grundlagen der KI verstehen, 
            wissen in Bezug auf unterschiedliche KI Werkzeuge für die Erstellung von Inhalten aufbauen und eine 
            KI Guideline für die Nutzung von solchen Werkzeugen in Schulumgebungen erarbeitet haben.
            </p>
              <li class="text-gray-600 flex items-center text-xs mb-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="icon icon-tabler icon-tabler-clock"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" />
                  <circle cx="12" cy="12" r="9" />
                  <polyline points="12 7 12 12 15 15" />
                </svg>
                <span class="mx-2">|</span>
                <p>60 min</p>
              </li>
            <div class="flex lg:items-center items-start flex-col lg:flex-row">
              <!-- <div class="flex items-center">
                <div class="border-2 border-white shadow rounded-full w-6 h-6">
                  <img
                    class="w-full h-full overflow-hidden object-cover rounded-full"
                    src="https://dh-ui.s3.amazonaws.com/assets/webapp/layout/grid_cards/grid_card8.jpg"
                    alt="avatar"
                  />
                </div>
                <div
                  class="-ml-2 border-2 border-white shadow rounded-full w-6 h-6"
                >
                  <img
                    class="w-full h-full overflow-hidden object-cover rounded-full"
                    src="https://dh-ui.s3.amazonaws.com/assets/webapp/layout/grid_cards/grid_card9.jpg"
                    alt="avatar"
                  />
                </div>
                <div
                  class="-ml-2 border-2 border-white shadow rounded-full w-6 h-6"
                >
                  <img
                    class="w-full h-full overflow-hidden object-cover rounded-full"
                    src="https://dh-ui.s3.amazonaws.com/assets/webapp/layout/grid_cards/grid_card10.jpg"
                    alt="avatar"
                  />
                </div>
                <div
                  class="-ml-2 border-2 border-white shadow rounded-full w-6 h-6"
                >
                  <img
                    class="w-full h-full overflow-hidden object-cover rounded-full"
                    src="https://dh-ui.s3.amazonaws.com/assets/webapp/layout/grid_cards/grid_card11.jpg"
                    alt="avatar"
                  />
                </div>
                <div
                  class="-ml-2 border-2 border-white shadow rounded-full w-6 h-6"
                >
                  <img
                    class="w-full h-full overflow-hidden object-cover rounded-full"
                    src="https://dh-ui.s3.amazonaws.com/assets/webapp/layout/grid_cards/grid_card12.jpg"
                    alt="avatar"
                  />
                </div>
                <p class="text-gray-600 text-xs font-normal ml-1">
                  +12 Attendees
                </p>
              </div> -->
              <div class="mt-4 lg:mt-0 ml-0 lg:ml-12 flex items-end">
                <span class="mr-1 text-gray-600">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-map-pin"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <circle cx="12" cy="11" r="3" />
                    <path
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 0 1 -2.827 0l-4.244-4.243a8 8 0 1 1 11.314 0z"
                    />
                  </svg>
                </span>
                <p
                  class="text-gray-600 text-sm tracking-normal font-normal text-center"
                >
                  Palmicken, Oberstufenzentrum
                </p>
              </div>
            </div>
          </div>
          <div
            class="px-5 lg:px-5 md:px-10 py-3 lg:py-4 md:flex flex-row items-center justify-between border-t border-gray-300"
          >
            <div class="flex items-center md:mb-0 mb-4">
              <div v-if="user.role.name > 0">
                <button 
                  type="submit" 
                  class="bg-purple-500 hover:bg-purple-600 text-white font-bold py-1 px-4 rounded-full"
                  @click="downloadFile"
                >
                  Material herunterladen <font-awesome-icon class="ml-3" :icon="['fas', 'arrow-down']" />
                </button> 
              </div>
              <div v-else>
                <router-link to="/login">
                  <button type="submit" class="bg-green-500 hover:bg-green-600 text-white font-bold py-1 px-4 rounded-full"> Anmelden um Material herunterzuladen <font-awesome-icon class="ml-3" :icon="['fas', 'arrow-right']" /></button>
                </router-link>               
              </div>
              <!-- <div class="flex items-center">
                <div
                  class="bg-white border 2 border-black rounded-full w-5 h-5 flex flex-shrink-0 justify-center items-center relative"
                >
                  <input
                    checked
                    type="radio"
                    name="radio"
                    class="checkbox appearance-none focus:outline-none border-none rounded-full border-gray-400 absolute cursor-pointer w-full h-full checked:border-none"
                  />
                  <div
                    class="check-icon hidden bg-black rounded-full w-3 h-3 z-1"
                  ></div>
                </div>
                <p class="ml-3 text-base leading-4 font-normal text-gray-800">
                  Teilnehmen
                </p>
              </div>
              <div class="flex items-center ml-6">
                <div
                  class="bg-white rounded-full w-5 h-5 flex flex-shrink-0 justify-center items-center relative border-black border"
                >
                  <input
                    type="radio"
                    name="radio"
                    class="checkbox appearance-none focus:outline-none rounded-full absolute cursor-pointer w-full h-full checked:border-none"
                  />
                  <div
                    class="check-icon hidden bg-black rounded-full w-3 h-3 z-1"
                  ></div>
                </div>
                <p class="ml-3 text-base leading-4 font-normal text-gray-800">
                  Nicht teilnehmen
                </p>
              </div> -->
            </div>
            <div class="flex items-center">
              <!-- <div
                class="text-gray-600 hover:text-gray-700 cursor-pointer mr-4"
              >
                <svg
                  class="feather feather-bookmark"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
                </svg>
              </div> -->
             <p @click="toggleDropdown()" class="cursor-pointer m-2">Teilen</p>
              <div 
                class="relative z-10 text-blue-700 hover:text-blue-600 cursor-pointer"
                @click="toggleDropdown()"
              >
                <svg
                  class="feather feather-share-2"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <circle cx="18" cy="5" r="3" />
                  <circle cx="6" cy="12" r="3" />
                  <circle cx="18" cy="19" r="3" />
                  <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
                  <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
                </svg>

                    <!-- Dropdown Menu -->
                <div v-show="showDropdown" class="absolute left-0 mt-2 bg-white border rounded shadow" @click.stop>
                  <a @click="shareViaWhatsApp" class="block px-4 py-2 cursor-pointer">via WhatsApp</a>
                  <a @click="shareViaEmail" class="block px-4 py-2 cursor-pointer">via Email</a>
                  <a @click="copyUrlWithButtonName" class="block px-4 py-2 cursor-pointer">Kopiere URL</a>
                  <a @click="closeDropdown" class="block px-4 py-2 cursor-pointer text-red-600">Schließen</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="relative w-full h-64 lg:h-auto lg:w-1/2 rounded-t lg:rounded-t-none lg:rounded-r inline-block"
        >
          <img
            class="w-full h-full absolute inset-0 object-cover rounded-t lg:rounded-r lg:rounded-t-none"
            src="https://myedubbosz01.s3.eu-central-1.amazonaws.com/175027266456469.png"
            alt="banner"
          />
        </div>
      </div>
      <br>
      <!-- Module 2 -->
      <div
        class="flex flex-col-reverse lg:flex-row w-full bg-white shadow rounded"
      >
        <div class="w-full lg:w-1/2">
          <div class="pt-4 lg:pt-6 pb-4 lg:pb-6 pl-4 lg:pl-6 pr-4 lg:pr-6">
            <div
              class="flex justify-between items-center lg:items-start flex-row-reverse lg:flex-col"
            >
              <h4 class="text-base text-blue-700 tracking-normal leading-4">
                Wird definiert
              </h4>
              <h4
                class="lg:mt-3 lg:text-gray-600 text-blue-700 text-base font-normal"
              >
                Wird definiert
              </h4>
            </div>
            <h2
              class="text-gray-800 mt-4 mb-2 tracking-normal text-xl lg:text-2xl font-bold"
            >
              AI4Teachers - Künstliche Intelligenz in der Schule
            </h2>
            <h3
              class="text-gray-600 mt-4 mb-2 tracking-normal text-xl lg:text-2xl font-bold"
            >
              Modul 2 - Wissensvermittlung & Einführung KI Tools
            </h3>
            <p
              class="mb-6 font-normal text-gray-600 text-sm tracking-normal w-11/12 lg:w-9/12"
            >
            Erkundung von KI-Tools für die Unterrichtsplanung und die Erstellung von Inhalten kann eine wertvolle Ressource für Lehrer sein, 
            um ihren Unterricht zu optimieren und ihren Schülern ein besseres Lernen zu ermöglichen. Diese Tools können Lehrern helfen, 
            ihren Unterricht zu personalisieren, indem sie Inhalte an die Bedürfnisse und Interessen der Schüler anpassen, 
            und sie können auch dazu beitragen, die Effizienz des Unterrichts zu verbessern, indem sie Lehrern helfen, Zeit zu sparen, 
            indem sie automatisierte Aufgaben erledigen.
            </p>
            <li class="text-gray-600 flex items-center text-xs mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-clock"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <circle cx="12" cy="12" r="9" />
                    <polyline points="12 7 12 12 15 15" />
                  </svg>
                  <span class="mx-2">|</span>
                  <p>60 min</p>
                </li>
            <div class="flex lg:items-center items-start flex-col lg:flex-row">
              <!-- <div class="flex items-center">
                <div class="border-2 border-white shadow rounded-full w-6 h-6">
                  <img
                    class="w-full h-full overflow-hidden object-cover rounded-full"
                    src="https://dh-ui.s3.amazonaws.com/assets/webapp/layout/grid_cards/grid_card8.jpg"
                    alt="avatar"
                  />
                </div>
                <div
                  class="-ml-2 border-2 border-white shadow rounded-full w-6 h-6"
                >
                  <img
                    class="w-full h-full overflow-hidden object-cover rounded-full"
                    src="https://dh-ui.s3.amazonaws.com/assets/webapp/layout/grid_cards/grid_card9.jpg"
                    alt="avatar"
                  />
                </div>
                <div
                  class="-ml-2 border-2 border-white shadow rounded-full w-6 h-6"
                >
                  <img
                    class="w-full h-full overflow-hidden object-cover rounded-full"
                    src="https://dh-ui.s3.amazonaws.com/assets/webapp/layout/grid_cards/grid_card10.jpg"
                    alt="avatar"
                  />
                </div>
                <div
                  class="-ml-2 border-2 border-white shadow rounded-full w-6 h-6"
                >
                  <img
                    class="w-full h-full overflow-hidden object-cover rounded-full"
                    src="https://dh-ui.s3.amazonaws.com/assets/webapp/layout/grid_cards/grid_card11.jpg"
                    alt="avatar"
                  />
                </div>
                <div
                  class="-ml-2 border-2 border-white shadow rounded-full w-6 h-6"
                >
                  <img
                    class="w-full h-full overflow-hidden object-cover rounded-full"
                    src="https://dh-ui.s3.amazonaws.com/assets/webapp/layout/grid_cards/grid_card12.jpg"
                    alt="avatar"
                  />
                </div>
                <p class="text-gray-600 text-xs font-normal ml-1">
                  +12 Attendees
                </p>
              </div> -->
              <div class="mt-4 lg:mt-0 ml-0 lg:ml-12 flex items-end">
                <span class="mr-1 text-gray-600">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-map-pin"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <circle cx="12" cy="11" r="3" />
                    <path
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 0 1 -2.827 0l-4.244-4.243a8 8 0 1 1 11.314 0z"
                    />
                  </svg>
                </span>
                <p
                  class="text-gray-600 text-sm tracking-normal font-normal text-center"
                >
                  Palmicken, Oberstufenzentrum
                </p>
              </div>
            </div>
          </div>
          <div
            class="px-5 lg:px-5 md:px-10 py-3 lg:py-4 md:flex flex-row items-center justify-between border-t border-gray-300"
          >
            <div class="flex items-center md:mb-0 mb-4">
              <div v-if="user.role.name > 0">
                <button 
                  type="submit" 
                  class="bg-purple-500 hover:bg-purple-600 text-white font-bold py-1 px-4 rounded-full"
                  @click="downloadFile2"
                >
                  Material herunterladen <font-awesome-icon class="ml-3" :icon="['fas', 'arrow-down']" />
                </button> 
              </div>
              <div v-else>
                <router-link to="/login">
                  <button type="submit" class="bg-green-500 hover:bg-green-600 text-white font-bold py-1 px-4 rounded-full"> Anmelden um Material herunterzuladen <font-awesome-icon class="ml-3" :icon="['fas', 'arrow-right']" /></button>
                </router-link> 
              </div>
              <!-- <div class="flex items-center">
                <div
                  class="bg-white border 2 border-black rounded-full w-5 h-5 flex flex-shrink-0 justify-center items-center relative"
                >
                  <input
                    checked
                    type="radio"
                    name="radio"
                    class="checkbox appearance-none focus:outline-none border-none rounded-full border-gray-400 absolute cursor-pointer w-full h-full checked:border-none"
                  />
                  <div
                    class="check-icon hidden bg-black rounded-full w-3 h-3 z-1"
                  ></div>
                </div>
                <p class="ml-3 text-base leading-4 font-normal text-gray-800">
                  Teilnehmen
                </p>
              </div>
              <div class="flex items-center ml-6">
                <div
                  class="bg-white rounded-full w-5 h-5 flex flex-shrink-0 justify-center items-center relative border-black border"
                >
                  <input
                    type="radio"
                    name="radio"
                    class="checkbox appearance-none focus:outline-none rounded-full absolute cursor-pointer w-full h-full checked:border-none"
                  />
                  <div
                    class="check-icon hidden bg-black rounded-full w-3 h-3 z-1"
                  ></div>
                </div>
                <p class="ml-3 text-base leading-4 font-normal text-gray-800">
                  Nicht teilnehmen
                </p>
              </div> -->
            </div>
            <div class="flex items-center">
              <p @click="toggleDropdown2()" class="cursor-pointer m-2">Teilen</p>
              <!-- <div
                class="text-gray-600 hover:text-gray-700 cursor-pointer mr-4"
              >
                <svg
                  class="feather feather-bookmark"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
                </svg>
              </div> -->
              <div 
                class="relative z-10 text-blue-700 hover:text-blue-600 cursor-pointer"
                @click="toggleDropdown2()"
              >
                <svg
                  class="feather feather-share-2"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <circle cx="18" cy="5" r="3" />
                  <circle cx="6" cy="12" r="3" />
                  <circle cx="18" cy="19" r="3" />
                  <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
                  <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
                </svg>
                <!-- Dropdown Menu -->
                <div v-show="showDropdown2" class="absolute left-0 mt-2 bg-white border rounded shadow" @click.stop>
                  <a @click="shareViaWhatsApp" class="block px-4 py-2 cursor-pointer">via WhatsApp</a>
                  <a @click="shareViaEmail" class="block px-4 py-2 cursor-pointer">via Email</a>
                  <a @click="copyUrlWithButtonName2" class="block px-4 py-2 cursor-pointer">Kopiere URL</a>
                  <a @click="closeDropdown" class="block px-4 py-2 cursor-pointer text-red-600">Schließen</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="relative w-full h-64 lg:h-auto lg:w-1/2 rounded-t lg:rounded-t-none lg:rounded-r inline-block"
        >
          <img
            class="w-full h-full absolute inset-0 object-cover rounded-t lg:rounded-r lg:rounded-t-none"
            src="https://myedubbosz01.s3.eu-central-1.amazonaws.com/183073129247163+(1).png"
            alt="banner"
          />
        </div>
      </div>
   <!--    <h5 class="mb-6 text-gray-900 font-medium mt-10">Past</h5> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data: function() {
    return {
      user: JSON.parse(localStorage.getItem("user"))
          ? JSON.parse(localStorage.getItem("user"))
          : { role: { name: 0 } },
      showDropdown: false,
      showDropdown2: false,
    };
  },
  // updated(){
  //   console.log("showDropdown",this.showDropdown)
  // },
  // beforeDestroy() {
  //   document.removeEventListener('click', this.closeDropdown);
  // },
  methods: {
    closeDropdown(event) {
      if (this.showDropdown) {
        this.showDropdown = false;
        event.preventDefault(); // Prevent the event from propagating
      }
      if (this.showDropdown2) {
        this.showDropdown2 = false;
        event.preventDefault(); // Prevent the event from propagating
      }
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
      if (this.showDropdown) {
       // document.addEventListener('click', this.closeDropdown);
      } else {
       // document.removeEventListener('click', this.closeDropdown);
      }
    },
    toggleDropdown2() {
      this.showDropdown2 = !this.showDropdown2;
      if (this.showDropdown2) {
       // document.addEventListener('click', this.closeDropdown);
      } else {
       // document.removeEventListener('click', this.closeDropdown);
      }
    },
    shareViaWhatsApp(event) {
      const currentUrl = window.location.href;
      //const buttonName = "Your Button Name"; // Replace with actual button name

      const whatsappLink = `https://api.whatsapp.com/send?text=${encodeURIComponent(
        `Schaue dir diesen Link an: ${currentUrl}`
      )}`;

        // Open in a new window
      const whatsappWindow = window.open(whatsappLink, '_blank');

      // Check if the new window was blocked by the browser
      if (!whatsappWindow || whatsappWindow.closed || typeof whatsappWindow.closed == 'undefined') {
        // Open in the same window if the new window was blocked
        window.location.href = whatsappLink;
      }

     // console.log(`Shared via WhatsApp: ${whatsappLink}`);
     if (this.showDropdown) {
        this.showDropdown = false;
        event.preventDefault(); // Prevent the event from propagating
      }

    },
    shareViaEmail(event) {
      // (your email sharing logic)
      const currentUrl = window.location.href;
      const emailSubject = "Check out this link";
      const emailBody = `Hi,\n\nI wanted to share this link with you: ${currentUrl}\n\nRegards,\n[Your Name]`;

      const mailtoLink = `mailto:?subject=${encodeURIComponent(
        emailSubject
      )}&body=${encodeURIComponent(emailBody)}`;

      // Use whatsappLink and mailtoLink as appropriate for your application
      // For example, you can open them in a new window or redirect the user
      // window.open(whatsappLink, '_blank');
      // window.open(mailtoLink, '_blank');

      // Redirect the user to the email client
      window.location.href = mailtoLink;

     // console.log(`Shared via Email: ${mailtoLink}`);
     if (this.showDropdown) {
        this.showDropdown = false;
        event.preventDefault(); // Prevent the event from propagating
      }
      
    },
    copyUrlWithButtonName(event) {
      const currentUrl = window.location.href;
      const buttonName = "Seminar AI4Teachers OSZ Modul 1 am 09.Oktober 2023 um 14 Uhr im OSZ Palmnicken: "; // Replace with actual button name
      const urlWithButtonName = `${buttonName}${currentUrl}`;

      // Copy the URL with the button name to the clipboard
      const tempInput = document.createElement("input");
      document.body.appendChild(tempInput);
      tempInput.value = urlWithButtonName;
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);
      
      if (this.showDropdown) {
        this.showDropdown = false;
        event.preventDefault(); // Prevent the event from propagating
      }

      // Show browser notification
      if ('Notification' in window) {
        Notification.requestPermission().then(function(permission) {
          if (permission === 'granted') {
            new Notification('URL Kopiert', { body: `Die URL wurde erfolgreich kopiert.` });
          }
        });
      }

    },
    copyUrlWithButtonName2(event) {
      const currentUrl = window.location.href;
      const buttonName = "Seminar AI4Teachers OSZ Modul 2 am 16.Oktober 2023 um 14 Uhr im OSZ Palmnicken: "; // Replace with actual button name
      const urlWithButtonName = `${buttonName}${currentUrl}`;

      // Copy the URL with the button name to the clipboard
      const tempInput = document.createElement("input");
      document.body.appendChild(tempInput);
      tempInput.value = urlWithButtonName;
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);
      
      if (this.showDropdown) {
        this.showDropdown = false;
        event.preventDefault(); // Prevent the event from propagating
      }

      // Show browser notification
      if ('Notification' in window) {
        Notification.requestPermission().then(function(permission) {
          if (permission === 'granted') {
            new Notification('URL Kopiert', { body: `Die URL wurde erfolgreich kopiert.` });
          }
        });
      }

    },
    downloadFile() {
      // Use JavaScript to trigger a download from Amazon S3.
      // This example uses a hypothetical S3 URL.
      const s3Url = 'https://myedubbosz01.s3.eu-central-1.amazonaws.com/AI_4_Teacher_OSZ_Modul_1_29e999bf46.pdf';
      // const link = document.createElement('a');
      // link.href = s3Url;
      // link.download = 'AI_4_Teacher_OSZ_Modul_1.pdf';
      // link.click();
      window.open(s3Url, '_blank');
    },
    downloadFile2() {
      // Use JavaScript to trigger a download from Amazon S3.
      // This example uses a hypothetical S3 URL.
      const s3Url = 'https://myedubbosz01.s3.eu-central-1.amazonaws.com/AI_4_Teacher_OSZ_Modul_2_ab8651db50.pdf';
      // const link = document.createElement('a');
      // link.href = s3Url;
      // link.download = 'AI_4_Teacher_OSZ_Modul_2.pdf';
      // link.click();
      window.open(s3Url, '_blank');
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("https://unpkg.com/tailwindcss@^2/dist/tailwind.min.css");
body {
  font-family: "Lato", sans-serif;
}
.checkbox:checked {
  border: none;
}
.checkbox:checked + .check-icon {
  display: flex;
}
.color-blue {
  color: #0047ab;
}
</style>
